import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { findProductos } from "../service/producto.service";
import { FilterProducto, HttpStatus, SUCCESS_SERVER, Moneda } from "../service/ENUM";
import { _IndentificadorMenu } from "../service/EnumMenu";

const LIMITE = 8;

function NewShopFeatured({ moneda = Moneda.DOLARES }) {
  const [items, setItems] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    const load = async () => {
      const lista = [];
      const rpt = await findProductos({
        chrCodigoFamilia: "110A",
        vchDescripcion: null,
        pagina: 1,
        limit: LIMITE,
        filterProducto: FilterProducto.FILTER_DESTACADO_MARCA,
      });
      if (rpt.status === HttpStatus.HttpStatus_OK) {
        const json = await rpt.json();
        if (json.response.status === SUCCESS_SERVER.SUCCES_SERVER_OK) {
          for (let i = 0; i < json.listaProductos.length; i++) {
            const e = json.listaProductos[i];
            lista.push({
              codigo: e.chrCodigoProducto,
              descripcion: e.vchDescripcion,
              precioDolar: e.numValorVentaDolarIgv,
              precioSoles: e.numValorVentaSolesIgv,
              imagen: e.imagenDefault ? e.imagenDefault.chrSrcImagen : "",
            });
          }
        }
      }
      setItems(lista);
    };
    load();
  }, []);

  const scroll = (dir) => {
    if (!sliderRef.current) return;
    const step = Math.round(sliderRef.current.clientWidth * 0.9);
    sliderRef.current.scrollBy({ left: dir * step, behavior: "smooth" });
  };

  const formatPrice = (item) => {
    if (moneda.numCodigoMoneda === Moneda.DOLARES.numCodigoMoneda) {
      return `$ ${parseFloat(item.precioDolar || 0).toFixed(2)}`;
    }
    return `S/ ${parseFloat(item.precioSoles || 0).toFixed(2)}`;
  };

  const resolveImage = (src) => {
    if (!src) return "https://via.placeholder.com/400x300?text=BMW";
    const compact = src.replace(/\s+/g, "");
    return `data:image/jpeg;base64,${compact}`;

  };

  if (items.length === 0) return null;

  return (
    <div className="nl-featured">
      <div className="nl-section__head">
        <h2 className="nl-title nl-title--small">Destacados</h2>
        <Link to={`/shop/${_IndentificadorMenu.TodoDestacado}/filter/all`} className="nl-section__link">
          Ver todo
        </Link>
      </div>
      <div className="nl-carousel-wrapper">
        <button
          aria-label="Anterior destacados"
          className="nl-slider-btn nl-slider-btn--left"
          onClick={() => scroll(-1)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="24" height="24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m15 19-7-7 7-7" />
          </svg>
        </button>
        <div
          ref={sliderRef}
          className="nl-carousel"
        >
          {items.map((item) => (
            <article key={item.codigo} className="nl-card">
              <div className="nl-card__img-wrap">
                <img
                  src={resolveImage(item.imagen)}
                  alt={item.descripcion}
                  className="nl-card__img"
                  loading="lazy"
                />
              </div>
              <h3 className="nl-card__title">{item.descripcion}</h3>
              <p className="nl-card__meta">{formatPrice(item)}</p>
            </article>
          ))}
        </div>
        <button
          aria-label="Siguiente destacados"
          className="nl-slider-btn nl-slider-btn--right"
          onClick={() => scroll(1)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" width="24" height="24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m9 5 7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default NewShopFeatured;
